 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		79: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = 'text/javascript';
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "static/js/" + ({"75":"vendor","76":"manage","77":"login","78":"index"}[chunkId]||chunkId) + "." + {"0":"d6216a225ba23d32d23f","1":"7d90b3152d2b6aaebdb8","2":"dd2ed4255605ebd4b5a8","3":"f096f72919c2e431efcb","4":"0a4c77fd265c7d9f9745","5":"86a8f5b501c19408748f","6":"98c06f16144b3ca0a11d","7":"a5f7f6bb1c04ff46de53","8":"1581fb5f32c962994ba4","9":"affcfe9268cafd7b1be5","10":"ae9f2be625ea8c6d9e8b","11":"e8489f9a5ced6337a48f","12":"04560b27248123aa2377","13":"c18aefc4a23eeacecc85","14":"125caa705357766c8919","15":"761cd3d693ff398e5e5d","16":"fd37aae30ae4e1bb0758","17":"9dc3639dcf1b2fe37b68","18":"ecd50b3772bf539b86b1","19":"765e7ed1cc4473759832","20":"1b44fc513d7a6fd58d41","21":"7eb13ade9b2680dce600","22":"106989f488d0eae8a712","23":"9c52f601526ce356fe37","24":"2e1c1ebcf9799273516c","25":"9dba05b8d8d5f11484c5","26":"d3d2d564f14acfb689ee","27":"a2b4053b644a03563eed","28":"f5520da6449a985c0b43","29":"cb322ccbbfa1ff7ddfe3","30":"7175f3644fd9c85877f6","31":"632ac27d7179816e2658","32":"7eeb056e80165c4cbb4d","33":"a162880fc24e2e7cecae","34":"a4dadb57789b63f0a86d","35":"35a1052963d8285fbcbb","36":"d6ee4287613911fb7a24","37":"34d0e937d8adf6e73170","38":"01749b1715aa9e2f707b","39":"115f1405afcbd71b8d20","40":"dce9944149eb77f00663","41":"a786557a1710d46ea52a","42":"5a8a420b37feaf0fc7bc","43":"47719bc994b027419e05","44":"0dde986772d83521e6c9","45":"147b652b5826e1115d6d","46":"a412969f0406a55399dc","47":"fff16e96ddc48593c8ec","48":"78fd31e41fd8d52faef9","49":"cffca304efccc925aae9","50":"3c5b041d49c6493b7cf3","51":"088f9a3f6bacd19b8185","52":"49e43b03c0aaa80b2d69","53":"8596f3b2b9f25c447872","54":"b17b283bdd93430f5134","55":"ec7227e86080e80c494a","56":"b1271411d07c4f729b62","57":"c28c2f07c148e1d1b6dd","58":"30032782ac0733f63736","59":"694580fd1e5ac6815c22","60":"c01b4e53f98e28fbffda","61":"d13d8bc936029bd30f00","62":"c9f4329c2cfdd64a3989","63":"a5291210bd035831f7d7","64":"5c75b709de7c6886eb6b","65":"03fc9ad72d9aa4e3cc45","66":"8e3b7fd3ae8577627b20","67":"061ff934419f6f511d11","68":"663765b93693f0ecab66","69":"3c44617bf2d06da66b49","70":"64afaa281fd2bd4ba644","71":"da633beaf1bfde7ef7a7","72":"508403ec4b0a43033f66","73":"f8543e26551ff12f9828","74":"89c1475043e04a8d9332","75":"1cd8a2bf249679a6f77c","76":"79e8372cefd2ebb9a50c","77":"4200592b07b41595ad2a","78":"ef0b2ad60a042169b3cd"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/jingle/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap 7f17b135ca98c201d3e0